import { CommonModule, DecimalPipe } from '@angular/common';
import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { AnalyticsService } from '../../../services/analytics.service';
import { DateUtilService } from '../../../services/dateUtil.service';
import { ProdutoMaisVendidoApi } from '../../../models/analytics.model';

@Component({
  selector: 'app-produtos-mais-vendidos-chart',
  standalone: true,
  imports: [CommonModule, DecimalPipe],
  templateUrl: './produtos-mais-vendidos-chart.component.html',
  styleUrls: ['./produtos-mais-vendidos-chart.component.css']
})
export class ProdutosMaisVendidosChartComponent implements OnInit {
  dados: ProdutoMaisVendidoApi[] = [];
  isLoading = true;
  hasError = false;
  totalVendas = 0;

  readonly dataInicial: string;
  readonly dataFinal: string;

  constructor(
    private analyticsService: AnalyticsService,
    private toastr: ToastrService,
    private cdr: ChangeDetectorRef,
    private dateUtilService: DateUtilService
  ) {
    const hoje = this.dateUtilService.dataHoje;
    const [year, month] = hoje.split('-');
    this.dataInicial = `${year}-${month}-01`;
    this.dataFinal = hoje;
  }

  ngOnInit(): void {
    this.carregarDados();
  }

  carregarDados(): void {
    this.isLoading = true;
    this.hasError = false;

    this.analyticsService.getProdutosMaisVendidos(this.dataInicial, this.dataFinal).subscribe({
      next: (data) => {
        this.dados = Array.isArray(data) ? data : [];
        this.totalVendas = this.dados.reduce((acc, item) => acc + (item.qtdVendas ?? 0), 0);
        this.isLoading = false;
        this.cdr.detectChanges();
      },
      error: () => {
        this.isLoading = false;
        this.hasError = true;
        this.toastr.error('Erro ao carregar os produtos mais vendidos.');
        this.cdr.detectChanges();
      }
    });
  }
}